__turbopack_context__.v({
  "hero": "BoardSectionTileSubjectsNewsWeather-module-scss-module__4BUxmW__hero",
  "mobiletitle": "BoardSectionTileSubjectsNewsWeather-module-scss-module__4BUxmW__mobiletitle",
  "newsTeaserHeadline": "BoardSectionTileSubjectsNewsWeather-module-scss-module__4BUxmW__newsTeaserHeadline",
  "radio": "BoardSectionTileSubjectsNewsWeather-module-scss-module__4BUxmW__radio",
  "rightRoot": "BoardSectionTileSubjectsNewsWeather-module-scss-module__4BUxmW__rightRoot",
  "showMobileTitle": "BoardSectionTileSubjectsNewsWeather-module-scss-module__4BUxmW__showMobileTitle",
  "teaserFixedHeight": "BoardSectionTileSubjectsNewsWeather-module-scss-module__4BUxmW__teaserFixedHeight",
  "widget": "BoardSectionTileSubjectsNewsWeather-module-scss-module__4BUxmW__widget",
});
